/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_RegionInputs */

const en_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const de_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const fr_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const es_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const it_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const nl_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const pl_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const fi_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const da_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const sv_portal_scanner_region = /** @type {(inputs: Portal_Scanner_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

/**
* | output |
* | --- |
* | "Region" |
*
* @param {Portal_Scanner_RegionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_region = /** @type {((inputs?: Portal_Scanner_RegionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_RegionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_region(inputs)
	if (locale === "fr") return fr_portal_scanner_region(inputs)
	if (locale === "es") return es_portal_scanner_region(inputs)
	if (locale === "it") return it_portal_scanner_region(inputs)
	if (locale === "nl") return nl_portal_scanner_region(inputs)
	if (locale === "pl") return pl_portal_scanner_region(inputs)
	if (locale === "fi") return fi_portal_scanner_region(inputs)
	if (locale === "da") return da_portal_scanner_region(inputs)
	if (locale === "sv") return sv_portal_scanner_region(inputs)
	return en_portal_scanner_region(inputs)
});